document.addEventListener('DOMContentLoaded', function() {
     const config = window.rugConfig || {};
     const btn = document.getElementById('customization-live-test');
     const overlay = document.getElementById('custom-popup-overlay');
     const loader = document.getElementById('live-test-loader');
     const closeBtn = document.getElementById('close-popup');
     const liveText = document.querySelector('#live-text-overlay span');
     const inputField = document.querySelector('input.customization-input');
     const popupImg = document.getElementById('popup-base-image');

     // 1. Yardımcı Fonksiyon: Font Yükleme (Promise)
     const loadFont = (fontLink) => {
          return new Promise((resolve, reject) => {
               if (!fontLink) return resolve();
               const link = document.createElement('link');
               link.rel = 'stylesheet';
               link.href = fontLink;
               link.onload = () => resolve();
               link.onerror = () => reject("Font Error.");
               document.head.appendChild(link);
          });
     };

     const loadImage = (src) => {
          return new Promise((resolve, reject) => {
               if (!src) return reject("Preview Error.");
               const img = new Image();
               img.src = src;
               img.onload = () => {
                    popupImg.src = src;
                    resolve();
               };
               img.onerror = () => reject("Image couldn't been loaded.");
          });
     };

     btn.addEventListener('click', async function() {
          if (!inputField || inputField.value.trim() === "") {
               inputField.classList.add('error');
               inputField.focus();
               return;
          } else {
               inputField.classList.remove('error');
          }
          loader.style.display = 'flex';

          try {
               await Promise.all([
                    loadFont(config.text_customization.font_link),
                    loadImage(config.text_customization.live_test_image),
                    new Promise(res => setTimeout(res, 1400))
               ]);

               liveText.innerText = inputField.value;
               loader.style.display = 'none';
               overlay.style.display = 'flex';

          } catch (error) {
               loader.style.display = 'none';
               alert("Sorry, we couldn't load the preview: " + error);
          }
     });

     if (inputField) {
          inputField.addEventListener('input', function() {
               if (this.value.trim() !== "") this.classList.remove('error');
               if (overlay.style.display === 'flex') {
                    liveText.innerText = this.value;
               }
          });
          inputField.setAttribute("maxlength", config.text_customization.max_length)
     }

     closeBtn.addEventListener('click', () => overlay.style.display = 'none');
     window.addEventListener('click', (e) => {
          if (e.target === overlay) overlay.style.display = 'none';
     });
});